<div class="modal-content">
  <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" *ngIf="this.formCreated">
    <div class="modal-header">
      <h5 class="modal-title" id="releaseNoteHeader" i18n="@@ReleaseNoteHeader">Modell bearbeiten</h5>
      <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
    </div>
    <div class="modal-body" i18n="@@ReleaseNoteContent">

      <div class="row mb-3">
        <div class="col-8">
          <div class="row mb-3">
            <label for="inputEmail3" class="col-sm-2 col-form-label">Hersteller*</label>
            <div class="col-sm-10">
              <input type="text" class="form-control" id="manufacturername" name="manufacturerName" formControlName="manufacturerName" value="{{modell?.manufacturer.name}}" required />
              <input type="hidden" name="manufacturerId" id="manufacturerId" value="{{ modell?.manufacturerId}}"/>
            </div>
          </div>
          <div class="row mb-3">
            <label for="model" class="col-sm-2 col-form-label">Modellname*</label>
            <div class="col-sm-10">
              <input type="text" class="form-control" id="modelname" name="modelname" value="{{modell?.name}}" formControlName="modelname" required>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-3 offset-sm-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isOcpp16" name="isOcpp16" value="1" formControlName="isOcpp16" [checked]="modell?.profile.isOcpp16">
                <label class="form-check-label" for="isOcpp16">
                  OCPP 1.6
                </label>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isOcpp20" name="isOcpp20" formControlName="isOcpp20" value="1" [checked]="modell?.profile.isOcpp20">
                <label class="form-check-label" for="isOcpp20">
                  OCPP 2.0
                </label>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isOcpp201" name="isOcpp201" formControlName="isOcpp201" value="1" [checked]="modell?.profile.isOcpp201">
                <label class="form-check-label" for="isOcpp201">
                  OCPP 2.0.1
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-3 offset-sm-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isErk" name="isErk" formControlName="isErk" value="1" [checked]="modell?.profile.isErk">
                <label class="form-check-label" for="isErk">
                  Eichrechtskonform
                </label>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isUpdatable" name="isUpdatable" formControlName="isUpdatable" value="1" [checked]="modell?.profile.isUpdatable">
                <label class="form-check-label" for="isUpdatable">
                  Firmware-Updates über OCPP möglich?
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-3 offset-sm-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isMobile" name="isMobile" formControlName="isMobile" value="1" [checked]="modell?.profile.isMobile">
                <label class="form-check-label" for="isMobile">
                  4G-Anbindung
                </label>
              </div>
            </div>
            <div class="col-sm-7">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isPnc" name="isPnc" formControlName="isPnc" value="1" [checked]="modell?.profile.isPnc">
                <label class="form-check-label" for="isPnc">
                  Plug'n'charge
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-3 offset-sm-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isAc" name="isAc" formControlName="isAc" value="1" [checked]="modell?.profile.isAc">
                <label class="form-check-label" for="isAc">
                  AC
                </label>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isDc" name="isDc" formControlName="isDc" value="1" [checked]="modell?.profile.isDc">
                <label class="form-check-label" for="isDc">
                  DC
                </label>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isBidi" name="isBidi" formControlName="isBidi" value="1" [checked]="modell?.profile.isBidi">
                <label class="form-check-label" for="isBidi">
                  Bi-Direktional
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-3 align-items-center">
            <label for="model" class="col-sm-2 col-form-label">Anzahl Ladepunkte*</label>
            <div class="col-sm-10">
              <input type="number" class="form-control" id="numberOfConnectors" name="numberOfConnectors" value="{{modell?.profile.numberOfConnectors}}" formControlName="numberOfConnectors" required>
            </div>
          </div>
          <div class="row mb-3">
            <label for="model" class="col-sm-2 col-form-label">Integration:</label>
            <div class="col-sm-10">
              <input type="datetime-local" value="{{ this.date}}" class="form-control" name="integrationDate" id="integrationDate"/>
              {{ this.datestring }}
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row mb-3">
            <label for="model" class="col-sm-2 col-form-label">Abbildung</label>
            <div class="col-sm-10">
              <input type="file" class="form-control d-none" id="pictureUri" name="pictureUri">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col text-center">
              <img src="{{modell?.pictureUri}}" class="img-fluid text-center" style="max-width:240px;height:auto;" />
            </div>
          </div>
          <div class="row-mb-3 d-none">
            <div class="form-group">
              <a class="btn"></a>
              <a class="btn"></a>
              <a class="btn"></a>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="modal-footer flex">
      <div class="float-end float-right">
        <button type="button" class="btn btn-yellow me-2" id="cancel" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CloseButton">Schließen</button>
        <button type="submit" id="save" class="btn btn-save" [disabled]="!form?.dirty" i18n="@@SaveButton">
          Speichern
        </button>
      </div>
    </div>
  </form>
</div>

